import { useQuery } from '@tanstack/react-query';
import { logger } from '@fiverr-private/obs';
import { AdminMember } from '../../types';
import { getMembersList } from '../../api/organizationInformation';

const getAdminData = async (): Promise<AdminMember> => {
    const data = await getMembersList();
    const admin = data.find((member) => member.role === 'admin');

    if (admin) {
        const { imageUrl, name, username, email } = admin;
        return {
            imageUrl,
            name,
            username,
            email,
        };
    }

    logger.error('admin not found', data);
    throw new Error('admin not found');
};

export const useGetAdminData = (isOpen: boolean, initialAdminData?: AdminMember) => {
    const {
        data,
        isError,
        isFetching: isLoading,
    } = useQuery({
        queryKey: ['initialAdminData'],
        queryFn: getAdminData,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        initialData: initialAdminData,
        enabled: !initialAdminData && isOpen,
        retry: 3,
    });

    return {
        admin: data,
        isError,
        isAdminDataLoading: isLoading,
    };
};
